//LOGO
export const logo = `${process.env.PUBLIC_URL}/safari-pinned-tab.svg`;
